import React, { useEffect, useState } from 'react'
import {
    Box, Container, Stack, Tooltip, Typography, Pagination,
    Link, Button,
    Modal,
    SwipeableDrawer,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    Tabs,
    Tab,
} from '@mui/material'
import * as API from '../utils/APICalls'
import * as helpers from '../utils/helpers'
import { DataGrid } from '@mui/x-data-grid'
import { TrackManager } from './TrackManager'
import { AlbumManager } from './AlbumManager'


// import CloseButton from '../../../components/CloseButton'
export const MusicManager = ({ artist }) => {

    const [tracks, setTracks] = useState()
    const [selectedAlbum, setSelectedAlbum] = useState()
    const [currentView, setCurrentView] = useState()
    const fetchTracks = async () => {
        try {
            const tracksResp = await API.fetchTracksByArtistId(artist?._id)

            if (tracksResp?.length > 0) {
                setTracks(tracksResp)
            }
        } catch (err) {
            console.log('Error Fetching Tracks', err)
        }
    }


    const trackColumns = [
        {
            field: 'details',
            headerName: 'view',
            width: 80,
            // editable: true,
            renderCell: (params) => {
                // if (!params.row?.location?.url) {
                return (
                    <Button
                        variant="contained"
                        // color={BtnStatusColor(params.row)}
                        size="small"
                    // disabled={!params.row?.location?.url}
                    // onClick={() => handleViewEventClick(params.row)}
                    >
                        view
                    </Button>
                );
                // } 

            },
        },
        {
            field: 'name',
            headerName: 'name',
            width: 130,
            renderCell: (params) => {
                return `${params.row?.name} ${params?.row?.subtitle ? params?.row?.subtitle : ''}`
            }
        },
        {
            field: 'guest_plays', headerName: 'Guest', width: 60,
            renderCell: (params) => {
                return params.row?.guest_plays?.length
            }

        },
        {
            field: 'listeners', headerName: 'Listeners', width: 60,
            renderCell: (params) => {
                return `${params.row?.listeners?.length}`
            }

        },
        {
            field: 'shares', headerName: 'Shares', width: 60,
            renderCell: (params) => {

                return params.row?.shares?.length
            }

        },
        {
            field: 'comments', headerName: 'Comments', width: 60,
            renderCell: (params) => {

                return params.row?.comments?.length
            }

        },
        {
            field: 'albums', headerName: '+->Album', width: 100,
            renderCell: (params) => {

                return (
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Set Length</InputLabel>
                        <Select
                            value={selectedAlbum}
                            label="length"
                            onChange={(e) => {
                                setSelectedAlbum(e.target.value)
                            }}
                        // {...register(`location.${f}`)} 
                        >
                            {artist?.albums?.map((a, i) => {
                                return (
                                    <MenuItem value={a} key={i}>{a?.title}</MenuItem>
                                )
                            })}

                        </Select>

                    </FormControl>
                )
            }

        },

        // {
        //     field: 'event_time',
        //     headerName: 'Time',
        //     width: 60,
        //     renderCell: (params) => {
        //         return helpers.convertMilitaryToAmPm(params.row?.event_time)
        //     }
        // },
        // {
        //     field: 'door_age',
        //     headerName: 'Age',
        //     width: 65,
        //     // editable: true,
        // },
        // {
        //     field: 'price',
        //     headerName: 'Price',
        //     width: 70,
        //     // editable: true,
        //     renderCell: (params) => {
        //         const adv = params.row?.price?.adv?.toLowerCase()
        //         const door = params.row?.price?.door?.toLowerCase()
        //         const priceString = adv !== door ? `$${adv ? adv + ' / ' : ''}${door ? door : ''}` : `$${adv}`
        //         let response = 'TBA'
        //         if ((adv === '0' && door === '0') || adv && door === 'free') {
        //             response = 'Free'
        //         }
        //         if (adv || door) {
        //             response = priceString
        //         }
        //         return response
        //     }

        // },

    ];

    useEffect(() => {
        const generateTracks = () => {

        }
        fetchTracks()
    }, [])
    const musicViews = ['albums', 'tracks', 'playlists']
    return (

        <Stack sx={{ justifyContent: 'center', padding: '0.5rem', overflow: 'scroll' }}>
            <Box sx={{ display: 'flex', margin: 'auto', position: 'relative', width: '100%', justifyContent: 'center' }}>
                {currentView === 'albums' && <Box sx={{ position: 'absolute', left: '0.5rem', top: '0.5rem', }}>
                    <Button>
                        + Album
                    </Button>

                </Box>}
                {currentView === 'tracks' && <Box sx={{ position: 'absolute', left: '0.5rem', top: '0.5rem', }}>
                    <Button>
                        + Track
                    </Button>

                </Box>}
                {currentView === 'playlists' && <Box sx={{ position: 'absolute', left: '0.5rem', top: '0.5rem', }}>
                    <Button>
                        + Playlist
                    </Button>

                </Box>}
                <Tabs sx={{ display: 'flex', }}
                    // textColor="#00FF00"
                    indicatorColor="#00FF00"
                // onChange={(e)=>setWalletView(e.target.value)}
                >

                    {musicViews?.map((v, i) => {
                        return (

                            <Tab label={v} value={v}
                                sx={{ color: currentView === v ? '#0000FF' : "#000" }}
                                onClick={(e) => setCurrentView(v)}
                            />
                        )
                    })}


                </Tabs>
            </Box>
            {currentView === 'albums' && <AlbumManager artist={artist} />}
            {currentView === 'tracks' && <TrackManager artist={artist} />}
        </Stack>

    )
}
